/** Per-GW rotation breakdown table — shared by Finder and Squad Planner. */
import React from "react";

export const fdrClass = (v, blank) => blank ? "bg-red-950 text-red-300"
    : v <= 2 ? "bg-emerald-500/80 text-black" : v <= 3 ? "bg-yellow-400/80 text-black" : "bg-red-500/80 text-black";

export default function RotationDetail({ row, showCs }) {
    return (
        <div className="p-3 space-y-2" data-testid={`rot-fdr-detail-${row.rank}`}>
            <p className="font-mono text-[10px] text-white/70 max-w-3xl leading-relaxed border-l-2 border-fa-mint pl-2">
                {row.explanation}
            </p>
            <div className="overflow-x-auto">
                <table className="font-mono text-[10px] w-full">
                    <thead>
                        <tr className="text-white/40 uppercase text-[8px] tracking-widest">
                            <th className="text-left px-2 py-1">GW</th>
                            {row.players.map((p) => <th key={p.id} className="text-left px-2 py-1">{p.name}</th>)}
                            <th className="text-left px-2 py-1">Staví se</th>
                            <th className="text-right px-2 py-1">Rotation FDR</th>
                        </tr>
                    </thead>
                    <tbody>
                        {row.per_gw.map((g) => {
                            const byId = Object.fromEntries(g.players.map((p) => [p.id, p]));
                            return (
                                <tr key={g.gw} className="border-t border-white/5">
                                    <td className="px-2 py-1 text-white/60 tabular-nums">GW{g.gw}</td>
                                    {row.players.map((p) => {
                                        const e = byId[p.id];
                                        return (
                                            <td key={p.id} className="px-2 py-1">
                                                <span className={`inline-block px-1.5 py-0.5 ${fdrClass(e.adj, e.blank)} ${g.selected.includes(p.id) ? "ring-1 ring-white" : "opacity-60"}`}
                                                      title={e.blank ? "Blank — tým nehraje" : `FDR ${e.adj} (oficiální ${e.official}${e.att != null ? ` · útok ${e.att} · obrana ${e.def}` : ""})${e.dgw ? " · DGW" : ""}${e.hist_ppg != null ? ` · osobní historie ${e.hist_ppg} PPG vs ${e.opp} (${e.hist_games} zápasů) — FDR upraveno` : ""}`}>
                                                    {e.label} {e.blank ? "" : e.adj}{e.hist_ppg != null ? " ★" : ""}
                                                </span>
                                                {showCs && !e.blank && e.cs_est != null && (
                                                    <span className="font-mono text-[8px] text-white/45 ml-1" title="Odhad šance na clean sheet (Poisson model z xG soupeře)">CS {e.cs_est}%</span>
                                                )}
                                            </td>
                                        );
                                    })}
                                    <td className="px-2 py-1 text-fa-mint">
                                        {g.selected.map((id) => row.players.find((p) => p.id === id)?.name).join(", ")}
                                    </td>
                                    <td className={`px-2 py-1 text-right tabular-nums font-bold ${g.rotation_fdr <= 2 ? "text-fa-mint" : g.rotation_fdr <= 3 ? "text-fa-yellow" : "text-red-300"}`}>
                                        {g.rotation_fdr}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <p className="font-mono text-[9px] text-white/35">
                Rámeček = hráč se v daném kole staví · zelená ≤2 · žlutá ≤3 · červená ≥4 · BLANK = tým nehraje (počítá se jako 5.5) · ★ = FDR upraveno podle osobní historie hráče proti tomuto soupeři (najetím myší detail)
            </p>
        </div>
    );
}
